module.exports = __webpack_public_path__ + "static/media/clipboard.4c085d3c.svg";